import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container mar_b" }
const _hoisted_2 = {
  class: "tab_content",
  "element-loading-background": "transparent"
}
const _hoisted_3 = { class: "tab_cont" }
const _hoisted_4 = { class: "num" }
const _hoisted_5 = { class: "sq_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "li_tit" }
const _hoisted_8 = { key: 0 }

import {reactive} from "vue";
import {useRouter} from "vue-router"
import {getOneThingItemList, simpleOneThingList} from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const router = useRouter()

const toPath = (item: any) => {
  router.push({
    path: '/simpleOneThing',
    query: {
      oneThingName: item.onethingName,
      flowUrl: item.flowUrl
    }
  })
}

const data = reactive({
  itemList: [] as any,
  total: 0,
  loading: true,
})

const getItemListData = async () => {
  let res = await simpleOneThingList() as any
  data.loading = false
  if (res.code === 200) {
    data.itemList = res.result
    data.total = res.result?.length
  }

}
getItemListData()



return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
        _createElementVNode("span", null, "首页"),
        _createTextVNode(),
        _createElementVNode("i", null, ">"),
        _createTextVNode(),
        _createElementVNode("span", null, "外贸一件事")
      ], -1)),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "共 " + _toDisplayString(data.total) + " 条数据", 1),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.itemList, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                onClick: ($event: any) => (toPath(item))
              }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.onethingName), 1)
              ], 8, _hoisted_6))
            }), 128))
          ]),
          (data.itemList.length === 0 && data.loading === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_el_empty, { description: "暂无数据" })
              ]))
            : _createCommentVNode("", true)
        ])
      ])), [
        [_directive_loading, data.loading]
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})